import React from "react";
import Modal from "react-bootstrap4-modal";
import { BeatLoader } from "react-spinners";
import MaskDecimal from "../../components/Util/MaskDecimal";

const FinancialDashboardUfModal = ({ visible, financeira, data, loading, onClose, exibirValores, getColumnHighlightClass }) => {
  function formatValue(colData) {
    if (!colData) return exibirValores ? "R$ 0,00" : "0";
    if (typeof colData === "object" && colData !== null) {
      const value = exibirValores ? colData.valorERC || 0 : colData.qtd || 0;
      return exibirValores ? MaskDecimal.TO_BRL(value) : value;
    }
    return exibirValores ? MaskDecimal.TO_BRL(colData || 0) : colData || 0;
  }

  function isZero(colData) {
    if (!colData) return true;
    if (typeof colData === "object" && colData !== null) {
      const value = exibirValores ? colData.valorERC || 0 : colData.qtd || 0;
      return value === 0;
    }
    return (colData || 0) === 0;
  }

  function colClass(col) {
    return getColumnHighlightClass ? getColumnHighlightClass(col) : "";
  }

  const colunas = (data && data.colunas) || [];
  const ufs = (data && data.ufs) || [];
  const totalPorColuna = (data && data.totalPorColuna) || [];

  const dialogClass = colunas.length <= 2 ? "modal-uf-dashboard-sm" : colunas.length <= 12 ? "modal-uf-dashboard-md" : "modal-uf-dashboard";

  return (
    <Modal visible={visible} onClickBackdrop={onClose} dialogClassName={dialogClass}>
      <div className="modal-header" style={{ padding: "8px 16px" }}>
        <h6 className="modal-title" style={{ margin: 0 }}>
          Produção por UF &mdash; <strong>{financeira ? (financeira.nomeAgrupamento || financeira.razaoSocial) : ""}</strong>
        </h6>
        <button
          type="button"
          onClick={onClose}
          style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", fontWeight: "bold", lineHeight: 1, color: "#333", padding: "0 0 0 12px" }}
        >
          &times;
        </button>
      </div>
      <div className="modal-body" style={{ padding: "8px 12px 4px" }}>
        {loading ? (
          <div className="text-center" style={{ padding: "30px" }}>
            <BeatLoader size={15} margin={2} color={"#58abc3"} loading={true} />
          </div>
        ) : ufs.length > 0 ? (
          <div className="financial-spreadsheet-container" style={{ maxHeight: "88vh", ...(colunas.length <= 2 ? { display: "flex", justifyContent: "center" } : {}) }}>
            <table className="financial-spreadsheet-table">
              <thead>
                <tr>
                  <th className="financial-spreadsheet-sticky-col" style={{ minWidth: "80px", maxWidth: "80px" }}>UF</th>
                  {colunas.map((col, i) => (
                    <th key={i} className={colClass(col)}>
                      {col.descricao}
                    </th>
                  ))}
                </tr>
                <tr className="financial-spreadsheet-totals-header">
                  <th className="financial-spreadsheet-sticky-col" style={{ minWidth: "80px", maxWidth: "80px" }}>Total:</th>
                  {totalPorColuna.map((total, i) => (
                    <th key={i} className={`${colClass(colunas[i])} ${isZero(total) ? "financial-spreadsheet-zero" : ""}`}>
                      {formatValue(total)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ufs.map((item, rowIndex) => (
                  <tr key={item.uf || rowIndex} className="financial-spreadsheet-parent-row">
                    <td className="financial-spreadsheet-sticky-col" style={{ minWidth: "80px", maxWidth: "80px", fontWeight: "600" }}>
                      {item.uf}
                    </td>
                    {item.dadosPorColuna.map((data, i) => (
                      <td key={i} className={`${colClass(colunas[i])} ${isZero(data) ? "financial-spreadsheet-zero" : ""}`}>
                        {formatValue(data)}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="financial-spreadsheet-sticky-col" style={{ minWidth: "80px", maxWidth: "80px" }}>Total:</td>
                  {totalPorColuna.map((total, i) => (
                    <td key={i} className={`${colClass(colunas[i])} ${isZero(total) ? "financial-spreadsheet-zero" : ""}`}>
                      {formatValue(total)}
                    </td>
                  ))}
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          <p className="text-center text-muted" style={{ marginTop: "20px" }}>
            Nenhum registro encontrado para o período selecionado.
          </p>
        )}
      </div>
      <div className="modal-footer" style={{ padding: "6px 16px" }}>
        <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
          Fechar
        </button>
      </div>
    </Modal>
  );
};

export default FinancialDashboardUfModal;
